
import React, { Component } from 'react';
import { Button, ButtonToolbar, Tabs, Tab} from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import { Checkbox } from 'react-icheck'
import moment from 'moment'
import WorkJobAssignTaskModal from './WorkJobAssignTaskModal'
import WorkdocStore from '../../../stores/WorkdocStore'
// import WorkJobMainEdit from './WorkJobMainEdit'
import WorkJobTimeTable from './WorkJobTimeTable'
import WorkJobPhoto from './WorkJobPhoto'
import WorkTimeRecord from './WorkTimeRecord'
import WorkJobEmployeeTable from './WorkJobEmployeeTable'
// import TextFieldModal from '../../../component/element/TextFieldModal'
import IframeModal from '../../../component/element/IframeModal'
// import FormJsonSchema from "react-jsonschema-form";
// import LayoutField from "react-jsonschema-form-layout";
import {  moneyFormatter } from '../../../utils/helpers'
import {connect} from 'react-redux'
class WorkJobEdit extends Component {

  constructor(...args) {
    super(...args)
    this.state = { data: {}, dataList: [], activeTab: '0',showField:false, showAssign: false,totalAmt: 0, totalCost: 0, totalDuration: 0, indexClick: -1, jobClick: -1, workState:[] }
  }

  loadWorkJob(item,workState) {
    if (!this.props.show) return
    
    this.setState({ data: item, workState: workState }, () => {
        this.refs.jobTime.getWrappedInstance().loadData(item.work_no,item,workState)
        // this.refs.jobPhoto.getWrappedInstance().loadData(item,workState)
        // this.refs.jobTimeRecord.getWrappedInstance().loadData(item.work_no)
        // this.refs.jobEmployee.getWrappedInstance().loadData(item.work_no)
    })
    //Loading
  }

  loadWorkDataList(workNo) {
    let that = this
    this.setState({ loading: true})
    WorkdocStore.loadWorkdocFixingListWithTask(workNo, function (result) {
      let totalAmt = 0, totalCost = 0;
      let minStartDate = null;
      let maxEndDate = null;
      let data = result.data.map((item, index) => {
        totalAmt += item.wage_cost * 1
        if (item.tasklist !== undefined && item.tasklist !== null) {
          item.tasklist = item.tasklist.map((titem, tindex) => {
            totalCost += titem.totalCost * 1
            titem.tasklist.map((ditem, dindex) => {
              let startDate = moment(ditem.startDate, "DD/MM/YYYY")
              let endDate = moment(ditem.endDate, "DD/MM/YYYY")
              if (!minStartDate || minStartDate.isAfter(startDate)) {
                minStartDate = startDate
              }
              if (!maxEndDate || maxEndDate.isBefore(endDate)) {
                maxEndDate = endDate
              }

              return ditem
            })

            return {
              bf_task_id: titem.bf_task_id, totalCost: titem.total_cost, data: titem.tasklist
              , person: { contractor_id: titem.contractor_id, first_name: titem.first_name, nick_name: titem.nick_name, last_name: titem.last_name }
            }

            //return titem
          })
        }
        return item
      })
      // console.log('loadWorkDataList', data)
      let totalDuration = (maxEndDate && minStartDate) ? moment.duration(maxEndDate.diff(minStartDate)).asDays() + 1 : 0;
      that.setState({ loading: false, dataList: data, totalAmt: totalAmt, totalCost: totalCost, totalDuration: totalDuration })
    }, function () {
      that.setState({loading:false})
    })
  }


  onBackClick() {
    this.setState({activeTab:'0'},()=>{
      this.props.onClose()
    })
  }

  onAssignClick(item, index) {
    let { dataList } = this.state
    this.setState({ showAssign: true, indexClick: index })
    this.refs.taskModal.getWrappedInstance().loadTask(dataList[index])
  }



  onTaskDelete(tasklist) {
    let { dataList, indexClick, jobClick } = this.state
    let that = this

    // let job = dataList[indexClick].tasklist[jobClick]
    // console.log('deleteJob',dataList[indexClick].tasklist[jobClick])
    WorkdocStore.delWorkdocFixingTask(tasklist.bf_task_id, function () {
      dataList[indexClick].tasklist.splice(jobClick, 1)
      that.setState({ dataList: dataList, jobClick: -1 })  
    }, function () {

    })
  }

  onTaskSave(jobData) {
    let { data, dataList, indexClick, jobClick } = this.state
    if (dataList[indexClick].tasklist === undefined || dataList[indexClick].tasklist == null)
      dataList[indexClick].tasklist = []

    if (jobClick >= 0) {
      dataList[indexClick].tasklist[jobClick] = jobData
    } else {
      dataList[indexClick].tasklist.push(jobData)
    }

    let meta = { work_no: data.work_no, contractor_id: jobData.person.contractor_id, employee_id: '', total_cost: jobData.totalCost, bf_work_damage_id: dataList[indexClick].bf_work_damage_id }
    let postData = { meta: meta, tasklist: jobData.data }
    let that = this
    WorkdocStore.saveWorkdocFixingTask(jobData.bf_task_id, postData, function (result) {
      that.setState({ dataList: dataList, jobClick: -1 })
      if (that.props.onStateChange !== undefined)
        that.props.onStateChange(data.work_no, result.taskstate)
      if (that.props.onReload !== undefined)
        that.props.onReload()  
    }, function () {

    })

  }

  onJobEdit(rowIndex, index) {
    let { dataList } = this.state
    let tasklist = dataList[rowIndex].tasklist[index]

    this.setState({ showAssign: true, indexClick: rowIndex, jobClick: index })
    this.refs.taskModal.getWrappedInstance().loadTask(dataList[rowIndex], tasklist)
  }

  onTabSelect(completeFunc=undefined,eventKey) {
    let { data,workState } = this.state
    this.setState({ activeTab: eventKey },()=>{
      if (completeFunc!==undefined)
        completeFunc()
      
      if (eventKey === '0') {
        this.refs.jobTime.getWrappedInstance().loadData(data.work_no,data,workState)
      } else if (eventKey === '1') {
        this.refs.jobEmployee.getWrappedInstance().onResetDisplay(()=>{
          this.refs.jobEmployee.getWrappedInstance().loadData(data.work_no)
        })
      } else if (eventKey === '2') {
        this.refs.jobPhoto.getWrappedInstance().loadData(data,workState)
      } else if (eventKey === '5') {
        this.refs.jobTimeRecord.getWrappedInstance().loadData(data.work_no)
      }  
    })
  }

  onInputFocused(fieldInfo){
    this.refs.textFieldModal.loadInfo(fieldInfo)
    //this.setState({showField:true,fieldInfo:fieldInfo})
  }

  onPrintClick(){
    let {activeTab} = this.state
    let url = ''
    if (activeTab==2) {
      if (process.env.NODE_ENV == "development") {
        url  = './?startPage=PrintFixingOrderDoc'
      } else {
        url = ''
      }
    }  
    this.refs.iframePrint.loadUrl(url)
  }

  onFormChange(){

  }

  renderDuration(item) {
    let {messages} = this.props
    if (item.taskStatus !== 2) {
      if (item.duration > 0)
        return (
          <span>{messages['Doing']} {item.duration} {messages['Day']} {messages['Dead Line']} {item.endDate}</span>
        )
      else {
        return (<span>{messages['No Date Set']}</span>)
      }
    } else {
      return (<span />)
    }
  }

  renderTaskStatus(item) {
    let {messages} = this.props
    if (item.taskStatus === '1') {
      return (<span><FontAwesome name='check-circle' className='text-green' />{messages['Fixing Status']}</span>)
    } else if (item.taskStatus === '2') {
      return (<span><FontAwesome name='check-circle' className='text-blue' />{messages['Done Status']}</span>)
    } else if (item.taskStatus === '3') {
      return (<span><FontAwesome name='check-circle' className='text-red' />{messages['Pause Status']}</span>)
    } else {
      return (<span />)
    }
  }

  renderDetail(detail) {
    if (detail === undefined || !detail) {
      detail = ''
    }
    return (<span>{detail}</span>)
  }

  renderJobList(rowIndex, tasklist) {
    let {messages} = this.props
    if (tasklist !== undefined && tasklist !== null) {
      return tasklist.map((jitem, jindex) => (
        <div key={jindex}>
          <h4><b><Button bsStyle='link' onClick={this.onJobEdit.bind(this, rowIndex, jindex)}>
            {jitem.person.first_name} <FontAwesome name='pencil' /></Button></b>
            {messages['Contractor Price']} {moneyFormatter.format(jitem.totalCost)} {messages['Bath']}
          </h4>
          {jitem.data.map((item, index) => (
            <div key={index}>{item.taskName} {this.renderDetail(item.detail)} {this.renderTaskStatus(item)} {this.renderDuration(item)} </div>
          ))}
        </div>
      )
      )
    } else {
      return (<div />)
    }
  }

  renderRowData() {
    let { dataList } = this.state
    let {messages} = this.props
    return dataList.map((item, index) => (
      <tr key={index}>
        <td className='text-center'>
          {index + 1}
        </td>
        <td>
          {item.detail}
        </td>
        <td className='text-center'>
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            checked={item.paint_flag === '1'}
            readOnly
          />
        </td>
        <td className='text-center' >
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            checked={item.fix_flag === '1'}
            readOnly
          />
        </td>
        <td className='text-center' >
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            checked={item.part_flag === '1' || item.stock_flag === '1'}
            readOnly
          />
        </td>
        <td className='text-right'>{item.wage_cost}</td>
        <td>
          <Button bsStyle='primary' onClick={this.onAssignClick.bind(this, item, index)}><FontAwesome name='plus' />&nbsp;{messages['Responsible Person']}</Button>
          {this.renderJobList(index, item.tasklist)}
        </td>
      </tr>
    ))
  }

  renderTable() {
    let { totalAmt, totalCost, totalDuration } = this.state
    totalAmt = moneyFormatter.format(totalAmt)
    totalCost = moneyFormatter.format(totalCost)
    let {messages} = this.props
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th className='text-center' style={{ width: '30px' }}>{messages['No']}</th>
            <th>{messages['Fixing List']}</th>
            <th className='text-center' style={{ width: '35px' }}>{messages['Hit-Paint']}</th>
            <th className='text-center' style={{ width: '30px' }}>{messages['Fixing']}</th>
            <th className='text-center' style={{ width: '30px' }}>{messages['Change']}</th>
            <th className='text-center' style={{ width: '100px' }}>{messages['Wage Approved']}</th>
            <th className='text-center' style={{ width: '400px' }}>{messages['Technician']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr>
            <th className='text-right' colSpan={5}>{messages['Total Wages']}</th>
            <th className='text-right'>{totalAmt}</th>
            <th className='text-right'>{messages['Total Durations']} {totalDuration} {messages['Day']} {messages['Contractor Fee']} {totalCost} {messages['Bath']}</th>
          </tr>
        </tfoot>
      </table>
    )
  }

  renderButton() {
    let {messages} = this.props
    return (
      <ButtonToolbar className='pull-right'>
        <Button onClick={this.onBackClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Back To Table']}</Button>
      </ButtonToolbar>
    )
  }

  // renderSummary(){
  //   const schema = {
  //     title: "โดยสรุป",
  //     type: "object",      
  //     properties: {
  //       total_cost_amount: {type: "string", title: "ต้นทุนค่าแรง"},
  //       total_wage_approve: {type: "string", title: "ค่าแรงอนุมัติ"},
  //       profit_amount: {type: "string", title: "กำไร"},        
  //     }
  //   }
  //   const uiSchema = {
  //     'ui:field': 'layout',
  //     'ui:layout': [
  //       { 
  //         total_cost_amount:{md:3},
  //         total_wage_approve:{md:3},
  //         profit_amount:{md:3}
  //       }              
  //     ]   
  //   }
        
  //   return (
  //     <FormJsonSchema 
  //       schema={schema}
  //       uiSchema={uiSchema}
  //       fields={{layout: LayoutField}}
  //       formData=""               
  //       onChange={this.onFormChange.bind(this)}
  //     >
        
  //   </FormJsonSchema>
  //   )
  // }

  // renderSummary2(){
    
  //   return (
  //     <div>
  //       <Row>
  //         <Col md={3}>
  //             <FormGroup
  //             controlId="formBasicText"              
  //           >
  //             <ControlLabel>ต้นทุนค่าแรง</ControlLabel>
  //             <FormControl
  //               type="text"
  //               value={'5000'}   
                                           
  //             />
  //             <FormControl.Feedback />              
  //           </FormGroup>
  //         </Col>
  //         <Col md={3}>
  //             <FormGroup
  //               controlId="formBasicText"              
  //             >
  //               <ControlLabel>ค่าแรงอนุมัติ</ControlLabel>
  //               <FormControl
  //                 type="text"
  //                 value={'6000'}     
                                            
  //               />
  //               <FormControl.Feedback />              
  //             </FormGroup>
  //         </Col>
  //         <Col md={3}>
  //             <FormGroup
  //               controlId="formBasicText"              
  //             >
  //               <ControlLabel>กำไรเบื้องต้น</ControlLabel>
  //               <FormControl
  //                 type="text"
  //                 value={'6000'}    
                                             
  //               />
  //               <FormControl.Feedback />              
  //             </FormGroup>
  //         </Col>
  //       </Row>
  //       <Row>
  //         <Col md={6}>          
  //             <FormGroup
  //               controlId="formBasicText"              
  //             >
  //               <ControlLabel>รายละเอียดอื่นๆ</ControlLabel>
  //               <FormControl
  //                 componentClass="textarea" 
  //                 placeholder="ใส่รายละเอียดงาน"
  //                 value={''}          
                 
  //               />
  //               <FormControl.Feedback />              
  //             </FormGroup>          
  //         </Col>
  //       </Row>
        
  //     </div>
  //   )
  // }

  onJobEmployeeClick(jobItem,workNo) {
    this.setState({ activeTab: '1' },()=>{
      this.refs.jobEmployee.getWrappedInstance().onJobEmployeeClick(jobItem,workNo)
    })
  }

  onJobTimeBack(completeFunc=undefined) {
    this.onTabSelect(()=>{
      if (completeFunc!==undefined)
        completeFunc()
    },'0')
  }

  renderTab(titleTask) {
    let {messages} = this.props
    let {activeTab} = this.state
    return (
      <Tabs
        activeKey={activeTab} 
        id="work-job-edit-tabs" 
        onSelect={this.onTabSelect.bind(this,undefined)}
      >
        <Tab eventKey="0"
          title={(<div><FontAwesome name="tasks"/> {messages['Job Status']} </div>)}>
          <WorkJobTimeTable 
              ref='jobTime'
              workState={this.state.workState}
              onStateChange={this.props.onStateChange} 
              onReload={this.props.onReload}
              onJobEmployeeClick={this.onJobEmployeeClick.bind(this)}
          />
        </Tab>
        <Tab eventKey="1"
          title={(<div><FontAwesome name="meh-o"/> {messages['Send Job']} </div>)}>
          <WorkJobEmployeeTable 
            ref='jobEmployee'
            onJobTimeBack={this.onJobTimeBack.bind(this)}
          />
        </Tab>  
        <Tab eventKey="2"
          title={(<div><FontAwesome name="camera"/> {messages['Image File']} </div>)}>
          <WorkJobPhoto 
            ref='jobPhoto'
            showPrint={true}
          />
        </Tab>
        <Tab eventKey="5"
          title={(<div><FontAwesome name="clock-o"/> {messages['Job Duration']} </div>)}>
          <WorkTimeRecord 
            ref='jobTimeRecord'
          />
        </Tab>
        {/* <Tab eventKey="4" title={(<div><FontAwesome name="dashboard"/> สรุปงาน</div>)}>
          {this.renderSummary()}
        </Tab> */}
      </Tabs>
    )
  }

  render() {
    if (!this.props.show) return null
    let { show, messages } = this.props
    let { data, dataList, showAssign, indexClick } = this.state
    let title = messages['Fixing List']+' '+data.work_no+' '+messages['Car Registration']+' ' +data.car_registration_no+' '+messages['Car/Model']+' '+data.car_detail

    let titleTask = (indexClick >= 0) ? dataList[indexClick].detail + ' '+messages['Wage Approved']+' ' + dataList[indexClick].wage_cost : ''
    return (
      <div style={{ display: (show) ? 'block' : 'none' }}>
        <Box loading={this.state.loading}>
          <Box.Header border={true}>
            <Box.Title>{title}</Box.Title>
          </Box.Header>
          <Box.Body>
            {this.renderTab(titleTask)}
            <WorkJobAssignTaskModal ref='taskModal' show={showAssign} title={titleTask}
              onDelete={this.onTaskDelete.bind(this)}
              onSave={this.onTaskSave.bind(this)}
              onHide={() => { this.setState({ showAssign: false }) }} />
          </Box.Body>
          <Box.Footer>
            {this.renderButton()}
          </Box.Footer>
          <IframeModal ref='iframePrint' title={messages['Print Document']} />
        </Box>
      </div>
    )
  }
}

export default WorkJobEdit = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkJobEdit}),null,null,{withRef:true}
)(WorkJobEdit);





// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkJobEdit.js